import { render, staticRenderFns } from "./VProduct.vue?vue&type=template&id=92a2d376"
import script from "./VProduct.vue?vue&type=script&lang=js"
export * from "./VProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports